export default __webpack_public_path__ + "static/media/vouchers-placeholder.70816471.jpg";